"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeltedArmorEffectHandler = exports.MeltedArmorEffectArgs = void 0;
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
const MaxAttributeDecrease_1 = require("./MaxAttributeDecrease");
class MeltedArmorEffectArgs {
    constructor() {
        this.__type = EffectType_1.EffectType.MeltedArmor;
        this.__typeName = "MeltedArmor";
        this.name = "MeltedArmor";
        this.harmful = true;
    }
}
exports.MeltedArmorEffectArgs = MeltedArmorEffectArgs;
let MeltedArmorEffectHandler = class MeltedArmorEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyDebuffs({
            sequence,
            attackerId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FireDamageImmunity, 10)
                },
                {
                    duration: Duration_1.Duration.Permanent,
                    effect: new MaxAttributeDecrease_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.AllDamageResistance, 10)
                }
            ],
            hidden: true
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        (state.meta.effectIds || []).forEach(effectId => container.cancelEffect(sequence, effectId));
    }
};
MeltedArmorEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.MeltedArmor)
], MeltedArmorEffectHandler);
exports.MeltedArmorEffectHandler = MeltedArmorEffectHandler;
